import { render } from "./SectionTransactionHistory.vue?vue&type=template&id=b397e378&scoped=true"
import script from "./SectionTransactionHistory.vue?vue&type=script&lang=js"
export * from "./SectionTransactionHistory.vue?vue&type=script&lang=js"

import "./SectionTransactionHistory.vue?vue&type=style&index=0&id=b397e378&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b397e378"]])

export default __exports__